import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import guards from './guards';
import Main from '@/views/layout/Main.vue';

// 动态加载路由模块
const modulesFiles = require.context('./modules', false, /\.js$/)
var modules = []
modulesFiles.keys().forEach((modulePath) => {
    const value = modulesFiles(modulePath)
    modules.push(...value.default)
}, {})

  const router = guards(createRouter({
    history: createWebHashHistory(),
    routes: [
      {
        path: '/',
        name: 'root',
        component: Main,
        redirect: '/home',
        children: modules // 先初始化为空数组
      },
      { path: '/:pathMatch(.*)*', redirect: '/', hidden: true }
    ]
  }));
  export default router;
